<div class="filter-container">
  <div *ngIf="filters.length > 0" class="search-head__filter">
    <button id="search" (click)="toggleAdvancedSearch()">Busca Avançada</button>
  </div>

  <div class="filters" [ngClass]="{ 'hidden': !showAdvancedSearch }">
    <app-dynamic *ngFor="let filter of filters" 
      [attribute]="filter"
      (onEmit)="handleFilterChange($event)">
    </app-dynamic>
  </div>
</div>
